import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=54b12027&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=54b12027&prod&lang=scss&scoped=true"
import style1 from "./Calendar.vue?vue&type=style&index=1&id=54b12027&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b12027",
  null
  
)

export default component.exports